// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._2WetJ{-ms-flex-direction:column;flex-direction:column;-ms-flex-align:center;align-items:center;background:#f9fafb;border-radius:16px;gap:16px;padding:12px}._2WetJ,._1jN6F{display:-ms-flexbox;display:flex}._1jN6F{-ms-flex-direction:row;flex-direction:row;-ms-flex-align:start;align-items:flex-start;gap:8px;width:100%}._1R94e{position:relative;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;background-color:#fff;border-radius:50%;display:-ms-inline-flexbox;display:inline-flex;height:40px;height:4rem;justify-content:center;overflow:hidden;width:40px;width:4rem;-ms-flex-negative:0;flex-shrink:0}@media (min-width:600px){._1R94e{margin-right:4px}}html[dir=ltr] ._1R94e{margin-right:1.6rem}html[dir=rtl] ._1R94e{margin-left:1.6rem}._1hPJg{max-height:100%;width:auto}._2jpFX{color:#fff;display:block;font-size:15px;font-size:1.5rem;font-weight:700}._25iqE{-ms-flex:1 1;flex:1 1}._3VNMe,._1OPNB{margin-left:auto}._1OPNB .btn__labelWrapper{padding:0}", ""]);
// Exports
exports.locals = {
	"visidCard": "_2WetJ",
	"visitInfo": "_1jN6F",
	"avatar": "_1R94e",
	"avatar__img": "_1hPJg",
	"avatar__initials": "_2jpFX",
	"avatar__name": "_25iqE",
	"emptyNotes": "_3VNMe",
	"showNotes": "_1OPNB"
};
module.exports = exports;
